import { render, staticRenderFns } from "./WithdrawBlock.vue?vue&type=template&id=8a652c4c&scoped=true&"
import script from "./WithdrawBlock.vue?vue&type=script&lang=js&"
export * from "./WithdrawBlock.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawBlock.vue?vue&type=style&index=0&id=8a652c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a652c4c",
  null
  
)

export default component.exports